import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';

interface Props {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  isModalOpen: boolean;
  loading?: boolean;
  modalClass?: string;
  save?: {
    label: string;
    disabledMessage?: string;
  };
  cancel?: {
    label: string;
    disabledMessage?: string;
  };
}

type EmitNames = 'onModalClose' | 'onCancelClick' | 'onSaveClick';

export default /*#__PURE__*/_defineComponent({
  __name: 'CcModal.ts',
  props: {
    size: { default: 'md' },
    isModalOpen: { type: Boolean },
    loading: { type: Boolean },
    modalClass: { default: '' },
    save: { default: () => ({
    label: 'Save',
  }) },
    cancel: { default: () => ({
    label: 'Cancel',
  }) }
  },
  setup(__props: any, { emit: emits }: { emit: ({ (e: EmitNames): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { size: 'sm' | 'md' | 'lg' | 'xl', isModalOpen: boolean, loading?: boolean, modalClass: string, save: {
    label: string;
    disabledMessage?: string;
  }, cancel: {
    label: string;
    disabledMessage?: string;
  } };





function handleEmits(emitName: EmitNames) {
  if (props.loading) return;
  emits(emitName);
}

return { __sfc: true,emits, props, handleEmits, CcIcon }
}

})